import React, { Component, Fragment } from 'react';
import axiosDefault from 'axios';
import { Alert } from 'antd';

export default (WrappedComponent, axios = axiosDefault) =>
  class extends Component {
    state = { error: null };

    componentWillMount() {
      this.reqInterceptor = axios.interceptors.request.use(
        (config) => {
          // console.log('[withErrorHandler] request config', config)
          this.setState((prevState) => ({ ...prevState, error: null }));
          return config;
        },
        (err) => {
          // console.log('[withErrorHandler] request error', err)
          return Promise.reject(err);
        },
      );

      this.resInterceptor = axios.interceptors.response.use(
        (response) => {
          // console.log('[withErrorHandler] response', response)
          return response;
        },
        (err) => {
          this.setState((prevState) => ({ ...prevState, error: err }));
          return Promise.reject(err);
        },
      );
    }

    componentWillUnmount() {
      axios.interceptors.request.eject(this.reqInterceptor);
      axios.interceptors.response.eject(this.resInterceptor);
    }

    errorConfirmHandler = () => {
      this.setState((prevState) => ({ ...prevState, error: null }));
    };

    render() {
      let alert = null;
      if (this.state.error) {
        alert = (
          <Alert
            style={{ position: 'absolute', width: '100%' }}
            message={`
                                ${this.state.error.message}:
                                ${
                                  this.state.error.response
                                    ? this.state.error.response.data.error
                                    : this.state.error.message
                                }
                            `}
            closable
            banner
            type="error"
            onClose={this.errorConfirmHandler}
          />
        );
      }

      return (
        <Fragment>
          {alert}
          <WrappedComponent {...this.props} />
        </Fragment>
      );
    }
  };



// WEBPACK FOOTER //
// ./src/HOC/Error/WithError.js